import React, { useEffect } from 'react'
import { Navigate } from "react-router-dom";
import { PaginaReporte } from "../../../Componentes/Compuestos/Paginas/PaginaReporte";
import LVButtonReporte from "../../../Componentes/Basicos/LVButtonReporte";


export const CON_Reportes_ = () => {

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }
  }, []);

  return (
    <PaginaReporte
      Titulo="REPORTES"
    >
      <div className="card-body">
        <div className="table-responsive">
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>

            <table>
              <tr style={{ height: '70px' }}>
                <td width={290} style={{ verticalAlign: 'middle' }} >
                  <LVButtonReporte Texto="Cliente" Url="/CON_Reporte_Cliente" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  Cuenta Corriente de Clientes

                </td>
              </tr>

              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="Cliente con Deuda" Url="/CON_Reporte_ClienteConDeuda" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  Clientes que actualmente tienen deuda
                </td>
              </tr>

              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="Cliente con Deuda Fecha Corte" Url="/CON_Reporte_ClienteConDeudaFechaCorte" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  Clientes que a determinada fecha tienen deuda
                </td>
              </tr>

              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="Proveedor" Url="/CON_Reporte_Proveedor" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  Cuenta Corriente de Proveedores
                </td>
              </tr>

              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="Proveedor con Deuda" Url="/CON_Reporte_ProveedorConDeuda" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  Proveedores que actualmente tienen deuda
                </td>
              </tr>

              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="Proveedor con Deuda Fecha Corte" Url="/CON_Reporte_ProveedorConDeudaFechaCorte" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  Proveedores que a determinada fecha tienen deuda
                </td>
              </tr>

              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="Artículo" Url="/CON_Reporte_Articulo" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  Uso de Artículo
                </td>
              </tr>

              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="Cuenta Financiera" Url="/CON_Reporte_CuentaFinanciera" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  Estado de Cuenta Financiera
                </td>
              </tr>

              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="Centro de Costo" Url="/CON_Reporte_CentroCosto" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  Estado de Centro de Costo
                </td>
              </tr>

              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="General Productivo" Url="/CON_Reporte_GeneralProductivo" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  Resumen Facturación / Cobranzas / Producción
                </td>
              </tr>

              
              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="I.V.A. Ventas" Url="/CON_Reporte_IVAVentas" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  I.V.A. Ventas
                </td>
              </tr>

              
              <tr style={{ height: '70px' }}>
                <td >
                  <LVButtonReporte Texto="I.V.A. Compras" Url="/CON_Reporte_IVACompras" Ancho={270} />
                </td>

                <td width={1300} style={{ fontSize: '20px', verticalAlign: 'middle', padding: '0px' }} >
                  I.V.A. Compras
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </PaginaReporte>
  );
};
